import React from "react";

// Benefit Icons
export const PromiseToCareIcons = {
  digitalizacion: ({ className = "", width = 48, height = 48 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g id="Digitalizaci&#195;&#179;n">
        <path
          id="Vector"
          d="M22.7409 27.4167L32.0273 18L29.6955 15.625L22.7409 22.7083L19.2636 19.1667L16.9727 21.5L22.7409 27.4167ZM6.5 39V35.6667H42.5V39H6.5ZM11.4091 34C10.5091 34 9.73864 33.6736 9.09773 33.0208C8.45682 32.3681 8.13636 31.5833 8.13636 30.6667V12.3333C8.13636 11.4167 8.45682 10.6319 9.09773 9.97917C9.73864 9.32639 10.5091 9 11.4091 9H37.5909C38.4909 9 39.2614 9.32639 39.9023 9.97917C40.5432 10.6319 40.8636 11.4167 40.8636 12.3333V30.6667C40.8636 31.5833 40.5432 32.3681 39.9023 33.0208C39.2614 33.6736 38.4909 34 37.5909 34H11.4091ZM11.4091 30.6667H37.5909V12.3333H11.4091V30.6667Z"
          fill="#697279"
        />
      </g>
    </svg>
  ),

  individualizacion: ({ className = "", width = 48, height = 48 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g id="Individualizaci&#195;&#179;n">
        <path
          id="Vector"
          d="M18.6743 42V18.195C15.8914 17.475 13.6667 15.9675 12 13.6725C10.3333 11.3775 9.5 8.82 9.5 6H13.1697C13.1697 8.49 13.9878 10.6125 15.6239 12.3675C17.2599 14.1225 19.3471 15 21.8853 15H26.4725C27.3899 15 28.2462 15.165 29.0413 15.495C29.8364 15.825 30.555 16.305 31.1972 16.935L39.5 25.08L36.9312 27.6L29.6835 20.49V42H26.0138V31.2H22.344V42H18.6743ZM24.1789 13.2C23.1697 13.2 22.3058 12.8475 21.5872 12.1425C20.8685 11.4375 20.5092 10.59 20.5092 9.6C20.5092 8.61 20.8685 7.7625 21.5872 7.0575C22.3058 6.3525 23.1697 6 24.1789 6C25.1881 6 26.052 6.3525 26.7706 7.0575C27.4893 7.7625 27.8486 8.61 27.8486 9.6C27.8486 10.59 27.4893 11.4375 26.7706 12.1425C26.052 12.8475 25.1881 13.2 24.1789 13.2Z"
          fill="#697279"
        />
      </g>
    </svg>
  ),

  conectividad: ({ className = "", width = 48, height = 48 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g id="Conectividad">
        <path
          id="Vector"
          d="M24.166 20.6667L18.4387 14.8333L24.166 9L29.8933 14.8333L24.166 20.6667ZM6.16602 39V32.3333C6.16602 31.3889 6.48647 30.5972 7.12738 29.9583C7.76829 29.3194 8.53874 29 9.43874 29H14.7978C15.3433 29 15.8615 29.1389 16.3524 29.4167C16.8433 29.6944 17.2387 30.0694 17.5387 30.5417C18.3297 31.625 19.3047 32.4722 20.4637 33.0833C21.6228 33.6944 22.8569 34 24.166 34C25.5024 34 26.7501 33.6944 27.9092 33.0833C29.0683 32.4722 30.0297 31.625 30.7933 30.5417C31.1478 30.0694 31.5637 29.6944 32.041 29.4167C32.5183 29.1389 33.016 29 33.5342 29H38.8933C39.8206 29 40.5978 29.3194 41.2251 29.9583C41.8524 30.5972 42.166 31.3889 42.166 32.3333V39H30.7115V35.2083C29.7569 35.9028 28.7274 36.4306 27.6228 36.7917C26.5183 37.1528 25.366 37.3333 24.166 37.3333C22.9933 37.3333 21.8478 37.1458 20.7297 36.7708C19.6115 36.3958 18.5751 35.8611 17.6206 35.1667V39H6.16602ZM11.0751 27.3333C9.71147 27.3333 8.55238 26.8472 7.59783 25.875C6.64329 24.9028 6.16602 23.7222 6.16602 22.3333C6.16602 20.9167 6.64329 19.7292 7.59783 18.7708C8.55238 17.8125 9.71147 17.3333 11.0751 17.3333C12.466 17.3333 13.6319 17.8125 14.5728 18.7708C15.5137 19.7292 15.9842 20.9167 15.9842 22.3333C15.9842 23.7222 15.5137 24.9028 14.5728 25.875C13.6319 26.8472 12.466 27.3333 11.0751 27.3333ZM37.2569 27.3333C35.8933 27.3333 34.7342 26.8472 33.7797 25.875C32.8251 24.9028 32.3478 23.7222 32.3478 22.3333C32.3478 20.9167 32.8251 19.7292 33.7797 18.7708C34.7342 17.8125 35.8933 17.3333 37.2569 17.3333C38.6478 17.3333 39.8137 17.8125 40.7547 18.7708C41.6956 19.7292 42.166 20.9167 42.166 22.3333C42.166 23.7222 41.6956 24.9028 40.7547 25.875C39.8137 26.8472 38.6478 27.3333 37.2569 27.3333Z"
          fill="#697279"
        />
      </g>
    </svg>
  ),

  ecoamigable: ({ className = "", width = 48, height = 48 }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g id="Eco-amigable">
        <path
          id="Vector"
          d="M12.996 35.8391C11.5397 34.3825 10.399 32.6994 9.57377 30.7897C8.74855 28.88 8.33594 26.9056 8.33594 24.8665C8.33594 22.8273 8.72428 20.8124 9.50095 18.8218C10.2776 16.8312 11.5397 14.962 13.2873 13.2141C14.4199 12.0813 15.8196 11.1102 17.4862 10.301C19.1528 9.49185 21.1269 8.85259 23.4084 8.38326C25.6898 7.91393 28.295 7.63072 31.2237 7.53361C34.1524 7.43651 37.429 7.5498 41.0535 7.87347C41.3124 11.3044 41.3933 14.4603 41.2962 17.341C41.1991 20.2217 40.9322 22.8192 40.4953 25.1335C40.0584 27.4478 39.4435 29.4707 38.6507 31.2024C37.8578 32.9341 36.8789 34.3825 35.7138 35.5478C33.9987 37.2632 32.1783 38.5175 30.2528 39.3105C28.3273 40.1035 26.3613 40.5 24.3549 40.5C22.2514 40.5 20.1965 40.0873 18.19 39.2619C16.1836 38.4366 14.4523 37.2956 12.996 35.8391ZM18.4328 35.0622C19.3712 35.6125 20.334 36.009 21.321 36.2518C22.3081 36.4945 23.3194 36.6159 24.3549 36.6159C25.8436 36.6159 27.316 36.3165 28.7723 35.7177C30.2286 35.1189 31.6201 34.156 32.9469 32.8289C33.5294 32.2463 34.12 31.429 34.7187 30.377C35.3174 29.3251 35.8352 27.9495 36.2721 26.2502C36.709 24.5509 37.0407 22.4955 37.2672 20.0841C37.4937 17.6728 37.5261 14.8001 37.3643 11.4663C35.7786 11.4015 33.9906 11.3773 32.0004 11.3934C30.0101 11.4096 28.028 11.5634 26.0539 11.8547C24.0799 12.146 22.2029 12.6153 20.423 13.2627C18.6431 13.91 17.1868 14.8001 16.0542 15.933C14.5979 17.3895 13.5947 18.8299 13.0445 20.2541C12.4944 21.6782 12.2193 23.0539 12.2193 24.3809C12.2193 26.2906 12.5834 27.9657 13.3115 29.406C14.0397 30.8464 14.6788 31.8579 15.229 32.4405C16.5881 29.8511 18.3842 27.3669 20.6172 24.9878C22.8501 22.6088 25.4552 20.6587 28.4325 19.1374C26.1025 21.1766 24.0718 23.4827 22.3404 26.056C20.6091 28.6292 19.3065 31.6313 18.4328 35.0622Z"
          fill="#697279"
        />
      </g>
    </svg>
  ),
};

export const renderIcon = (iconName) => {
  const IconComponent = PromiseToCareIcons[iconName];
  return IconComponent ? <IconComponent /> : null;
};
